export enum FileType {
    Unknown = 0,

    Image = 1,

    Pdf = 2,

    png = 3,

    csv = 4,

    gif = 5,

    xls = 6,

    xlsx = 7,

    jpg = 8,

    kml = 9,

    kmz = 10,

    txt = 11,

    svg = 12,

    docx = 13,

    pptx = 14,
    jpeg = 15


}